import {
  $PatchedCustomerOrganisationRequest,
  $PhoneForwardingRuleRequest
} from '@/types/generated/schemas.gen'

/**
 * OpenAPI object schema shape emitted by ``schemas.gen.ts``.
 */
export type OpenApiObjectSchema = {
  properties?: Record<string, { maxLength?: number } | undefined>
}

/** Read maxLength for a string field from a generated OpenAPI request schema. */
export function getSchemaFieldMaxLength(
  schema: OpenApiObjectSchema,
  fieldName: string
): number | undefined {
  const field = schema.properties?.[fieldName]
  if (field === undefined || field.maxLength === undefined) {
    return undefined
  }
  return field.maxLength
}

/** Max length for PhoneForwardingRule.forwarding_message from the API schema. */
export function getPhoneForwardingMessageMaxLength(): number {
  return getSchemaFieldMaxLength($PhoneForwardingRuleRequest, 'forwarding_message') ?? 255
}

/** Max length for PhoneForwardingRule.from_text_context from the API schema. */
export function getPhoneForwardingTextContextMaxLength(): number {
  return getSchemaFieldMaxLength($PhoneForwardingRuleRequest, 'from_text_context') ?? 255
}

/** Max length for Organisation.description from the API schema. */
export function getOrganisationDescriptionMaxLength(): number {
  return getSchemaFieldMaxLength($PatchedCustomerOrganisationRequest, 'description') ?? 400
}

/** True when value length is within maxLength (inclusive). */
export function isTextWithinMaxLength(value: string, maxLength: number): boolean {
  return value.length <= maxLength
}

/** True when value length exceeds maxLength. */
export function exceedsMaxLength(value: string, maxLength: number): boolean {
  return value.length > maxLength
}
